import React, { useEffect } from 'react';

function Blog() {
  useEffect(()=>{
    window.scrollTo({
        top:0,
        behavior:"smooth"
    })
},[])
  return (
    <div>
      <h2>Welcome to Our Blog</h2>
      <div style={blogPostStyle}>
        <h3>New Sticker Designs Available!</h3>
        <p>Hey there! We're thrilled to announce the release of our newest sticker designs! Dive into our latest collection and discover a world of vibrant and creative designs. From adorable animals to trendy patterns, there's something for everyone!</p>
      </div>
      <div style={blogPostStyle}>
        <h3>How to Create Stunning Digital Designs</h3>
        <p>Ever wondered how to create stunning digital designs? Well, wonder no more! In this blog post, we're sharing some top-secret tips and tricks to help you craft eye-catching designs that will wow your audience. Whether you're a beginner or a seasoned pro, there's always something new to learn!</p>
      </div>
      <div style={blogPostStyle}>
        <h3>Behind the Scenes: Our Design Process</h3>
        <p>Come take a peek behind the curtain and get an exclusive look at our design process! From brainstorming sessions to final product launches, we're pulling back the curtain and giving you a front-row seat to all the action. Get ready to be inspired!</p>
      </div>
    </div>
  );
}

const blogPostStyle = {
  marginBottom: '20px',
  padding: '20px',
  border: '1px solid #ccc',
  borderRadius: '8px',
};

export default Blog;
